import { useLocation } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { NAV_SECTIONS } from '@/constants/navigation';
import type { NavItem } from '@/constants/navigation';

interface Crumb {
  label: string;
  path?: string;
}

function findCrumbs(sections: NavItem[], pathname: string): Crumb[] {
  for (const section of sections) {
    // Exact leaf match
    if (section.path && (pathname === section.path || pathname.startsWith(section.path + '/'))) {
      return [{ label: section.label, path: section.path }];
    }
    // Group — check children
    if (section.children) {
      for (const child of section.children) {
        if (child.path && (pathname === child.path || pathname.startsWith(child.path + '/'))) {
          return [
            { label: section.label },
            { label: child.label, path: child.path },
          ];
        }
      }
    }
  }
  return [];
}

export const Breadcrumb = () => {
  const { pathname } = useLocation();
  const crumbs: Crumb[] = pathname === '/'
    ? [{ label: 'Dashboard' }]
    : findCrumbs(NAV_SECTIONS, pathname);

  if (crumbs.length === 0) return null;

  return (
    <nav aria-label="Breadcrumb" className="flex items-center gap-1 text-sm">
      {crumbs.map((crumb, i) => (
        <span key={i} className="flex items-center gap-1">
          {i > 0 && <ChevronRight size={14} className="text-gray-400" />}
          <span
            className={
              i === crumbs.length - 1
                ? 'text-gray-900 dark:text-gray-100 font-medium'
                : 'text-gray-500 dark:text-gray-400'
            }
          >
            {crumb.label}
          </span>
        </span>
      ))}
    </nav>
  );
};
